import { Localize } from "@dp-instant/i18n";
import { apiClient } from "@game/api/ApiClient";

const POLL_INTERVAL = 5000;
const POLL_TIMEOUT = 10 * 60 * 1000; // 10 minutes

class TributeDepositTracker {
  private pending = new Map<number, number>(); // depositId → trackStartTime
  private intervalId: number | null = null;

  track(depositId: number): void {
    if (this.pending.has(depositId)) return; // already tracking
    this.pending.set(depositId, Date.now());
    if (!this.intervalId) {
      this.intervalId = window.setInterval(() => this.poll(), POLL_INTERVAL);
    }
  }

  untrack(depositId: number): void {
    this.pending.delete(depositId);
    if (this.pending.size === 0 && this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  private async poll(): Promise<void> {
    for (const [id, startTime] of this.pending) {
      // Timeout: stop polling after 10 minutes
      if (Date.now() - startTime > POLL_TIMEOUT) {
        this.pending.delete(id);
        continue;
      }

      try {
        const status = await apiClient.getTributeDepositStatus(id);

        if (status.status === "completed") {
          this.pending.delete(id);
          try { await apiClient.getMe(); } catch {}
          apiClient.emitHardBalanceUpdate();

          const tg = (window as any).Telegram?.WebApp;
          const msg = Localize.get("ui-tribute-confirmed", "Your payment has been confirmed!");
          try {
            tg?.showPopup?.({
              title: Localize.get("ui-tribute-received", "Payment received"),
              message: msg,
              buttons: [{ type: "ok" }],
            });
          } catch {
            try {
              tg?.showAlert?.(msg);
            } catch {}
          }
        } else if (status.status === "expired") {
          this.pending.delete(id);
        }
      } catch {
        // continue polling
      }
    }

    if (this.pending.size === 0 && this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}

export const tributeDepositTracker = new TributeDepositTracker();
